export const analyticsEndpoints = {
  getRevenue: "/graphs/revenue/",
  getUsers: "/graphs/users/",
  getCustomers: "/graphs/customers/",
  getConnections: "/graphs/connections/",
  getIntegrations: "/graphs/integrations/",
  getFirstRegistration: "/graphs/first-registration/",
  getNiches: "/graphs/niches/",
  getSoloVsSalon: "/graphs/solo-vs-salon/",
  getCouponAffiliateStats: "/payment/coupon-affiliate-stats/",
};
